module.exports = __webpack_public_path__ + "img/section-1-child1.7cf9c2c9.png";